module.exports = __webpack_public_path__ + "96aeeaf4670d9a830b6ce66408369b3d.pdf";